module.exports = __webpack_public_path__ + "img/model_market_card4.545c166e.png";